var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsUnsubscribedActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13,
    viewBox: "0 0 17.1 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remove-email-svgrepo-com",
    transform: "translate(-2.25 -4.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2588",
    "data-name": "Path 2588",
    d: "M4,7l5.373,4.03a2.6,2.6,0,0,0,3.12,0L17.867,7",
    transform: "translate(-0.133 -0.267)",
    fill: "rgba(120,127,136,0)",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2589",
    "data-name": "Path 2589",
    d: "M10.8,17.133H4.733A1.733,1.733,0,0,1,3,15.4V6.733A1.733,1.733,0,0,1,4.733,5H16.867A1.733,1.733,0,0,1,18.6,6.733v4.333",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2590",
    "data-name": "Path 2590",
    d: "M15.762,14.762a2.6,2.6,0,1,0,3.677,3.677m-3.677-3.677a2.6,2.6,0,1,1,3.677,3.677m-3.677-3.677L17.6,16.6l1.838,1.838",
    transform: "translate(-1.6 -1.2)",
    fill: "rgba(120,127,136,0)",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsUnsubscribedActiveIcon);
export default __webpack_public_path__ + "static/media/settings-unsubscribed-active-icon.ad59bfccfba28a2b1c4a3e6b4299301d.svg";
export { ForwardRef as ReactComponent };